import React from 'react';
import LoginFormContainer from './LoginFormContainer';

const LoginPage = () => {
  return (
      <LoginFormContainer />
  );
};

export default LoginPage;
